'use client'

import axios, { AxiosRequestConfig } from 'axios'
import { useCallback, useState } from 'react'
import { getPublicEnv } from '@tucan/utils'

export const useApiProxy = (url: string) => {
  const [ data, setData ] = useState(null)
  const [ loading, setLoading ] = useState(false)
  const [ error, setError] = useState()

  const trigger = useCallback(async ( config: AxiosRequestConfig) => {
    setLoading(true)
    setData(null)
    setError(undefined)
    try {
      const res = await axios(getPublicEnv('ENDPOINT') + url, config)

      setData(res.data)
      setLoading(false)

      return res.data
    } catch(error) {
      setError(error)
      throw error
    }
  }, [url])

  return { data, error, loading, trigger }
}
